import { trans } from '@spotahome/soyuz/client';
import './Hero.scss';

const HERO_IMAGES = [
  {
    src: 'https://static.spotahome.com/images/how-it-works/image-1.jpg',
    altKey: 'how_it_works.hero.image.alt.1'
  },
  {
    src: 'https://static.spotahome.com/images/how-it-works/image-2.jpg',
    altKey: 'how_it_works.hero.image.alt.2'
  },
  {
    src: 'https://static.spotahome.com/images/how-it-works/image-3.jpg',
    altKey: 'how_it_works.hero.image.alt.3'
  }
];

const Hero = () => {
  return (
    <section className="hiw-hero">
      <h1 className="hiw-hero__title">
        {trans('ambassador.looking_for_you.hiw.title')}
      </h1>
      <div className="hiw-hero__images">
        {HERO_IMAGES.map(({ src, altKey }) => (
          <img
            key={src}
            className="hiw-hero__images__item"
            src={src}
            alt={trans(altKey)}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
